// extracted by mini-css-extract-plugin
export default {"wrap":"e77901c31018","integration":"c939b408d64a","content":"a0818dc0ea31","title":"d9e38932e1d5","subtitle":"b28df3e68b46"};